export default "__VITE_ASSET__BPIQTjHU__"